@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.dropdown-menu {
  padding: 20px;
}

.dropdown-menu > p {
  margin-top: 0;
}

.icon-wrapper {
  display: flex;
  padding: @space-8;
  background-color: @app-header--pr-build-menu--background-color;
  color: @app-header--dropin-menu--text-color;
  align-items: center;
  font-size: 24px;
  border-radius: @space-4;
  svg {
    height: @space-24;
    width: @space-36;
    fill: @app-header--dropin-menu--fill-color;
  }
}
